<div class="loginMain">
  <div class="login">
    <h1 style="color: #5baf1e; margin-top: 10px" class="text-center">
      Institute for Training in Ministry
    </h1>
    <div class="logo text-center">
      <img
        src="./assets/images/logo.png"
        class="img-fluid"
        style="width: 80px"
      />
    </div>
    <div class="loginBox">
      <form [formGroup]="formGroup" *ngIf="formGroup">
        <div class="form-group">
          <label for="exampleInputEmail1">First Name</label>
          <input
            type="text"
            class="form-control input"
            name="email"
            formControlName="firstName"
            placeholder="First Name"
            [class.is-invalid]="isControlInvalid('firstName')"
            [class.is-valid]="isControlValid('firstName')"
            autocomplete="off"
          />
          <h5
            class="invalid-feedback"
            *ngIf="controlHasError('required', 'firstName')"
          >
            This field is required
          </h5>
          <h5
            class="invalid-feedback"
            *ngIf="controlHasError('maxlength', 'firstName')"
          >
            Please enter a value shorter or equal to 50 characters.
          </h5>
        </div>
        <div class="form-group">
          <label for="exampleInputPassword1">Last Name</label>
          <input
            type="text"
            name="password"
            class="form-control input"
            formControlName="lastName"
            placeholder="Last Name"
            [class.is-invalid]="isControlInvalid('lastName')"
            [class.is-valid]="isControlValid('lastName')"
            autocomplete="off"
          />
          <h5
            class="invalid-feedback"
            *ngIf="controlHasError('required', 'lastName')"
          >
            This field is required
          </h5>
          <h5
            class="invalid-feedback"
            *ngIf="controlHasError('maxlength', 'lastName')"
          >
            Please enter a value shorter or equal to 50 characters.
          </h5>
        </div>

        <div class="form-group">
          <label for="exampleInputEmail1">Email address</label>
          <input
            type="text"
            class="form-control input"
            name="email"
            formControlName="email"
            placeholder="Email"
            [class.is-invalid]="isControlInvalid('email')"
            [class.is-valid]="isControlValid('email')"
            autocomplete="off"
          />
          <h5
            class="invalid-feedback"
            *ngIf="controlHasError('required', 'email')"
          >
            This field is required
          </h5>
          <h5
            class="invalid-feedback"
            *ngIf="controlHasError('pattern', 'email')"
          >
            Please enter a valid email
          </h5>
        </div>

        <div class="form-group">
          <label for="exampleInputEmail1">Church Name</label>
          <input
            type="text"
            class="form-control input"
            name="church_name"
            formControlName="church_name"
            placeholder="Church Name"
            [class.is-invalid]="isControlInvalid('church_name')"
            [class.is-valid]="isControlValid('church_name')"
            autocomplete="off"
          />
          <h5
            class="invalid-feedback"
            *ngIf="controlHasError('required', 'church_name')"
          >
            This field is required
          </h5>
          <h5
            class="invalid-feedback"
            *ngIf="controlHasError('maxlength', 'church_name')"
          >
            Please enter a value shorter or equal to 50 characters.
          </h5>
        </div>

        <div class="form-group">
          <label for="exampleInputEmail1">Address</label>
          <input
            type="text"
            class="form-control input"
            name="address"
            formControlName="address"
            placeholder="Address"
            [class.is-invalid]="isControlInvalid('address')"
            [class.is-valid]="isControlValid('address')"
            autocomplete="off"
          />
          <h5
            class="invalid-feedback"
            *ngIf="controlHasError('required', 'address')"
          >
            This field is required
          </h5>
          <h5
            class="invalid-feedback"
            *ngIf="controlHasError('maxlength', 'address')"
          >
            Please enter a value shorter or equal to 50 characters.
          </h5>
        </div>

        <div class="form-group">
          <label for="exampleInputEmail1">Size Of The Church</label>
          <select
            name="Size Of The Church"
            class="custom-select"
            class="form-control input"
            formControlName="size_of_the_church"
          >
            <option disabled selected value="0">
              Select Size Of The Church
            </option>
            <option value="1">x < 100</option>
            <option value="2">100 < x < 500</option>
            <option value="3">500 < x < 3000</option>
            <option value="4">x > 3000</option>
          </select>
          <h5
            class="invalid-feedback"
            *ngIf="controlHasError('required', 'size_of_the_church')"
          >
            This field is required
          </h5>
        </div>

        <div class="form-group">
          <label for="exampleInputPassword1">Password</label>
          <input
            type="password"
            name="password"
            class="form-control input"
            formControlName="password"
            placeholder="Password"
            [class.is-invalid]="isControlInvalid('password')"
            [class.is-valid]="isControlValid('password')"
            autocomplete="off"
          />
          <h5
            class="invalid-feedback"
            *ngIf="controlHasError('required', 'password')"
          >
            This field is required
          </h5>
        </div>
        <div class="form-group">
          <label for="exampleInputPassword1">Confirm Password</label>
          <input
            type="password"
            name="password"
            class="form-control input"
            placeholder="Confirm Password"
            formControlName="confirm_password"
            [class.is-invalid]="isControlInvalid('confirm_password') || isMatch"
            [class.is-valid]="isControlValid('confirm_password')"
            autocomplete="off"
          />
          <h5
            class="invalid-feedback"
            *ngIf="controlHasError('required', 'confirm_password')"
          >
            This field is required
          </h5>
          <h5 class="invalid-feedback" *ngIf="isMatch">
            Confirm Password must be same as Password
          </h5>
        </div>
        <button
          type="submit"
          class="btn btn-block btnSecondary"
          (click)="save()"
        >
          Register
        </button>
        <div class="form-group">
          <label class="form-text"
            >Already have an account?
            <a class="link" routerLink="/session">Login</a></label
          >
        </div>
      </form>
    </div>
  </div>
</div>
